export default function InsuranceProviders() {
    return [
        { value: "Americo Financial", label: "Americo Financial" },
        { value: "AXA Equitable", label: "AXA Equitable" },
        { value: "Brighthouse Financial", label: "Brighthouse Financial" },
        { value: "Great Southern", label: "Great Southern" },
        { value: "Guardian Life", label: "Guardian Life" },
        { value: "John Hancock", label: "John Hancock" },
        { value: "Lincoln Financial", label: "Lincoln Financial" },
        { value: "MassMutual", label: "MassMutual" },
        { value: "Mutual of Omaha", label: "Mutual of Omaha" },
        { value: "Nationwide", label: "Nationwide" },
        { value: "New York Life", label: "New York Life" },
        { value: "Northwestern Mutual", label: "Northwestern Mutual" },
        { value: "Pacific Life", label: "Pacific Life" },
        { value: "Penn Mutual", label: "Penn Mutual" },
        { value: "Primerica", label: "Primerica" },
        { value: "Principal Financial", label: "Principal Financial" },
        { value: "Prudential", label: "Prudential" },
        { value: "Securian", label: "Securian" },
        { value: "State Farm", label: "State Farm" },
        { value: "Transamerica", label: "Transamerica" },
        { value: "USAA", label: "USAA" },
        { value: "Other", label: "Other" },
    ];
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/InsuranceProviders.js